import { render } from "./Form.vue?vue&type=template&id=212de940&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=212de940&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-212de940"

export default script